import React, { useEffect } from "react";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";

/**
 * ImageProtection: zentraler Schutz vor casual Bildklau.
 *
 * Wirkung:
 *   • Rechtsklick auf <img> → verhindert Kontextmenü + Warn-Toast.
 *   • Drag & Drop auf <img> → verhindert das Ziehen + Warn-Toast.
 *   • CSS: user-select / touch-callout / user-drag deaktiviert für alle Bilder.
 *
 * Opt-Out: Bild-Tag mit `data-no-protect` versehen (z. B. Admin-Vorschauen).
 * Kein echter Schutz vor Screenshots, nur eine sichtbare Nutzungshürde.
 */
let _lastToastAt = 0;
function warn() {
  const now = Date.now();
  if (now - _lastToastAt < 2500) return;
  _lastToastAt = now;
  toast.error("Bilder sind urheberrechtlich geschützt", {
    description: "Speichern, Kopieren oder Weiterverwenden ist nicht gestattet.",
    duration: 3200,
    icon: <ShieldAlert className="w-4 h-4" />,
    id: "img-protection",
  });
}

function isProtectedImg(target) {
  if (!target || target.nodeType !== 1) return false;
  if (target.tagName !== "IMG") return false;
  if (target.hasAttribute("data-no-protect")) return false;
  return true;
}

export default function ImageProtection() {
  useEffect(() => {
    const onCtx = (e) => {
      if (!isProtectedImg(e.target)) return;
      e.preventDefault();
      warn();
    };
    const onDrag = (e) => {
      if (!isProtectedImg(e.target)) return;
      e.preventDefault();
      warn();
    };
    document.addEventListener("contextmenu", onCtx, true);
    document.addEventListener("dragstart", onDrag, true);
    return () => {
      document.removeEventListener("contextmenu", onCtx, true);
      document.removeEventListener("dragstart", onDrag, true);
    };
  }, []);

  return (
    <style>{`
      img:not([data-no-protect]) {
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
      }
    `}</style>
  );
}
